import { render, staticRenderFns } from "./c_home_text.vue?vue&type=template&id=7698400e&scoped=true"
import script from "./c_home_text.vue?vue&type=script&lang=js"
export * from "./c_home_text.vue?vue&type=script&lang=js"
import style0 from "./c_home_text.vue?vue&type=style&index=0&id=7698400e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7698400e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7698400e')) {
      api.createRecord('7698400e', component.options)
    } else {
      api.reload('7698400e', component.options)
    }
    module.hot.accept("./c_home_text.vue?vue&type=template&id=7698400e&scoped=true", function () {
      api.rerender('7698400e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileFormConfig/c_home_text.vue"
export default component.exports